import { Section } from "../../../components/Section";
import { HouseholdCompositionForm } from "./forms/HouseholdCompositionForm";
import { MonthlyCommitmentsForm } from "./forms/MonthlyCommitmentsForm";
import { BackgroundBorrowingForm } from "./forms/BackgroundBorrowingForm";
import { HouseholdComposition, ExpenditureDetails, BackgroundProperties } from "../../../types/mortgage";

interface ExpenditureSectionProps {
  household: HouseholdComposition;
  expenditure: ExpenditureDetails;
  background: BackgroundProperties;
  onHouseholdChange: (household: HouseholdComposition) => void;
  onExpenditureChange: (expenditure: ExpenditureDetails) => void;
  onBackgroundChange: (background: BackgroundProperties) => void;
  householdExpenditure: any;
  mortgageCalculations: any;
  totalCostsCalculations: any;
  onsMatrix: any;
  isAdmin?: boolean;
}

export function ExpenditureSection({
  household,
  expenditure,
  background,
  onHouseholdChange,
  onExpenditureChange,
  onBackgroundChange,
  householdExpenditure,
  mortgageCalculations,
  totalCostsCalculations,
  onsMatrix,
  isAdmin = false,
}: ExpenditureSectionProps) {
  return (
    <div className="space-y-6">
      {/* Household Composition Section */}
      <Section title="Household Composition" colorTheme={2}>
        <HouseholdCompositionForm
          household={household}
          onChange={onHouseholdChange}
          householdExpenditure={householdExpenditure}
          onsMatrix={onsMatrix}
        />
      </Section>

      {/* Monthly Outgoings Section */}
      <Section title="Monthly Outgoings" colorTheme={3}>
        <MonthlyCommitmentsForm
          household={household}
          expenditure={expenditure}
          background={background}
          onExpenditureChange={onExpenditureChange}
          householdExpenditure={householdExpenditure}
          totalCostsCalculations={totalCostsCalculations}
          onsMatrix={onsMatrix}
          isAdmin={isAdmin}
        />
      </Section>

      {/* Total Background Borrowing Section */}
      <Section title="Total Background Borrowing" colorTheme={0}>
        <BackgroundBorrowingForm
          background={background}
          onBackgroundChange={onBackgroundChange}
        />
      </Section>
    </div>
  );
}
